<div style="cursor: pointer;">
  <div *ngIf="viewDetail === 'triage-body'">
    <div *ngIf="genderAge === 'M'" class="body-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_01_intero.png" usemap="#Map-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
      </div>
      <map name="Map-man">
        <area shape="circle" coords="301,183,47" alt="testa"(click)="showPartPage('triage-head')" />
        <area shape="circle" coords="306,278,47" alt="collo"  (click)="showPartPage('triage-head')" />
        <area shape="circle" coords="351,384,47" alt="braccia" (click)="showPartPage('triage-arms')" />
        <area shape="circle" coords="253,354,47" alt="torace" (click)="showPartPage('triage-chaist')" />
        <area shape="circle" coords="247,492,44" alt="stomaco" (click)="showPartPage('triage-stomach')" />
        <area shape="circle" coords="327,468,38" alt="schiena" (click)="showPartPage('triage-back')" />
        <area shape="circle" coords="378,586,44" alt="mani" (click)="showPartPage('triage-hands')" />
        <area shape="circle" coords="299,561,37" alt="bacino"  (click)="showPartPage('triage-pelvis')" />
        <area shape="circle" coords="306,791,47"alt="gambe"  (click)="showPartPage('triage-legs')" />
        <area shape="circle" coords="300,974,47"  alt="piedi"  (click)="showPartPage('triage-foots')" />
  
        <area shape="poly" coords="66,685,69,688,71,691,73,692,77,692,89,692,92,691,96,689,98,686,100,683,101,674,100,598,102,597,104,594,106,591,106,510,104,506,99,501,96,500,80,499,85,496,87,493,91,489,94,480,94,475,93,468,90,463,86,456,78,453,72,450,62,449,55,451,47,455,42,462,39,470,39,475,39,482,40,488,48,497,51,500,37,501,33,502,29,502,26,507,24,510,24,579,24,592,27,598,33,602,33,684,36,689,42,692,59,692,62,688,64,685" alt="pelle" (click)="showBodyPartPage('MADI','Pelle')" />
        <area shape="poly" coords="68,886,68,972,70,976,73,978,76,979,88,979,92,977,94,975,96,973,96,884,99,882,102,881,103,877,103,794,100,790,96,788,75,788,75,780,79,778,83,776,87,772,88,769,90,764,90,757,89,751,84,743,77,738,71,737,67,736,61,737,53,738,52,739,48,742,43,751,41,757,41,762,42,768,46,772,52,779,56,780,56,788,35,789,30,790,27,792,25,802,26,879,28,883,36,886,36,972,38,978,41,978,57,979,60,978,63,970,62,886,68,886" alt="corpo" (click)="showBodyPartPage('ZG','Corpo')" />
      </map>

    </div>
    <div *ngIf="genderAge === 'F'" class="body-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_01_intero.png" usemap="#Map-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
      </div>
      <map name="Map-woman">
        <area shape="circle" coords="309,178,50" alt="testa" (click)="showPartPage('triage-head')" />
        <area shape="circle" coords="311,275,44" alt="collo" (click)="showPartPage('triage-head')" />
        <area shape="circle" coords="347,365,44" alt="braccia" (click)="showPartPage('triage-arms')" />
        <area shape="circle" coords="255,345,46" alt="torace"  (click)="showPartPage('triage-chaist')" />
        <area shape="circle" coords="248,495,44" alt="stomaco" (click)="showPartPage('triage-stomach')" />
        <area shape="circle" coords="326,452,44" alt="schiena"  (click)="showPartPage('triage-back')" />
        <area shape="circle" coords="388,578,40"  alt="mani"  (click)="showPartPage('triage-hands')" />
        <area shape="circle" coords="309,560,40" alt="bacino" (click)="showPartPage('triage-pelvis')" />
        <area shape="circle" coords="316,792,50" alt="gambe"  (click)="showPartPage('triage-legs')" />
        <area shape="circle" coords="303,975,45" alt="piedi" (click)="showPartPage('triage-foots')" />
  
        <area shape="poly" coords="65,687,58,694,43,693,31,683,31,600,25,592,25,504,31,500,51,500,42,491,39,480,39,471,41,463,48,454,57,449,70,449,76,448,82,451,89,460,94,471,94,479,93,487,91,493,84,496,79,501,89,500,97,500,103,505,107,510,108,530,108,558,108,594,100,602,101,683,98,689,94,691,89,694,72,694" alt="pelle" (click)="showBodyPartPage('MADI','Pelle')" />
        <area shape="poly" coords="55,790,55,781,47,773,42,765,42,759,45,753,45,745,50,740,55,737,70,737,78,738,83,742,88,748,90,756,91,762,91,768,87,773,85,776,79,779,76,781,76,788,86,790,92,790,98,789,102,792,104,798,103,813,103,836,103,868,104,876,104,879,103,882,100,884,96,886,95,930,95,977,89,980,78,980,73,979,68,974,68,968,68,886,63,886,62,976,59,979,56,980,51,981,41,981,39,978,35,973,34,885,31,883,27,879,28,793,33,789,55,791" alt="corpo" (click)="showBodyPartPage('ZG','Corpo')" />
      </map>
    </div>
    <div *ngIf="genderAge === 'B'" class="body-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_01_intero.png" usemap="#Map-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
      </div>
      <map name="Map-child">
        <area shape="circle" coords="315,187,48" alt="testa" (click)="showPartPage('triage-head')" />
        <area shape="circle" coords="318,297,48" alt="collo" (click)="showPartPage('triage-head')" />
        <area shape="circle"  coords="341,391,48" alt="braccia" (click)="showPartPage('triage-arms')" />
        <area shape="circle" coords="245,393,48" alt="torace" (click)="showPartPage('triage-chaist')" />
        <area shape="circle"coords="253,512,48" alt="stomaco" (click)="showPartPage('triage-stomach')" />
        <area shape="circle"  coords="348,487,48" alt="schiena" (click)="showPartPage('triage-back')" />
        <area shape="circle"coords="250,609,48" alt="mani" (click)="showPartPage('triage-hands')" />
        <area shape="circle" ccoords="345,601,48"alt="bacino" (click)="showPartPage('triage-pelvis')" />
        <area shape="circle"coords="314,790,48"  alt="gambe"  (click)="showPartPage('triage-legs')" />
        <area shape="circle" coords="316,972,48" alt="piedi"  (click)="showPartPage('triage-foots')" />
  
        <area shape="rect" coords="24,446,106,696" alt="pelle" (click)="showBodyPartPage('MADI','Pelle')" />
        <area shape="rect" coords="24,730,106,980" alt="corpo"  (click)="showBodyPartPage('ZG','Corpo')" />
      </map>
    </div>
    <div *ngIf="genderAge === 'N'" class="body-baby">
      <div class="image-body-parts neonato-corpo">
        <img src="../../../../assets/Neonato_01_intero.png" usemap="#Map-baby" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-baby">
        <area shape="circle" coords="325,204,50" alt="testa" (click)="showPartPage('triage-head')" />
        <area shape="circle" coords="320,350,48" alt="collo" (click)="showPartPage('triage-head')" />
        <area shape="circle" coords="355,440,48" alt="braccia"  (click)="showPartPage('triage-arms')" />
        <area shape="circle" coords="255,420,48" alt="torace"  (click)="showPartPage('triage-chaist')" />
        <area shape="circle" coords="250,515,48" alt="stomaco" (click)="showPartPage('triage-stomach')" />
        <area shape="circle" coords="360,538,48" alt="schiena"  (click)="showPartPage('triage-back')" />
        <area shape="circle" coords="195,595,48" alt="mani" (click)="showPartPage('triage-hands')" />
        <area shape="circle" coords="323,644,48" alt="bacino" (click)="showPartPage('triage-pelvis')" />
        <area shape="circle" coords="326,814,48" alt="gambe" (click)="showPartPage('triage-legs')" />
        <area shape="circle" coords="333,968,48" alt="piedi" (click)="showPartPage('triage-foots')" />

        <area shape="rect" coords="24,446,106,696" alt="pelle" (click)="showBodyPartPage('MADI','Pelle')" />
        <area shape="rect" coords="24,730,106,980" alt="corpo" (click)="showBodyPartPage('ZG','Corpo')" />
    </map>
    </div>
  </div>

  <div *ngIf="viewDetail === 'triage-head'">
    <div *ngIf="genderAge === 'M'" class="head-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_02_testa.png" usemap="#Map-head-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map id="Map-head-man" name="Map-head-man">
        <area shape="circle" coords="343,233,50" alt="Capelli" (click)="showBodyPartPage('TECH', 'Capelli')" />
        <area shape="circle" coords="180,316,50" alt="frontale" (click)="showBodyPartPage('TEFR','Fronte')" />
        <area shape="circle" coords="470,315,50" alt="occipitale" (click)="showBodyPartPage('TECR','Cranio')" />
        <area shape="circle" coords="125,415,50" alt="frontale" (click)="showBodyPartPage('TEYE','Occhi')" />
        <area shape="circle" coords="350,457,50" alt="orecchio" (click)="showBodyPartPage('TEOR','Orecchie')" />
        <area shape="circle" coords="74,504,50" alt="naso"  (click)="showBodyPartPage('TENE','Naso')" />
        <area shape="circle" coords="233,524,50" alt="zigomi" (click)="showBodyPartPage('TEVI','Guancia')" />
        <area shape="circle" coords="131,591,50" alt="bocca" (click)="showBodyPartPage('TEBO','Bocca')" />
        <!--  -->
        <area shape="poly" coords="15,1009,115,1008,116,989,87,989,87,976,75,964,76,958,76,953,72,946,66,942,60,941,52,941,47,944,42,954,41,962,44,968,49,973,56,974,60,974,64,974,74,985,74,989,16,989" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'F'" class="head-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_02_testa.png" usemap="#Map-head-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-head-woman">
        <area shape="circle" coords="333,203,50" alt="Capelli" (click)="showBodyPartPage('TECH', 'Capelli')" />
        <area shape="circle" coords="165,292,50" alt="Fronte" (click)="showBodyPartPage('TEFR','Fronte')" />
        <area shape="circle" coords="469,316,50" alt="Cranio" (click)="showBodyPartPage('TECR','Cranio')" />
        <area shape="circle" coords="103,404,50" alt="Occhi" (click)="showBodyPartPage('TEYE','Occhi')" />
        <area shape="circle" coords="342,439,50" alt="Orecchie" (click)="showBodyPartPage('TEOR','Orecchie')" />
        <area shape="circle" coords="61,493,45" alt="Naso" (click)="showBodyPartPage('TENE','Naso')" />
        <area shape="circle" coords="219,510,50" alt="Guancia" (click)="showBodyPartPage('TEVI','Guancia')" />
        <area shape="circle" coords="99,577,45" alt="Bocca"  (click)="showBodyPartPage('TEBO','Bocca')" />
        <area shape="circle" coords="471,663,50" alt="Nuca" (click)="showBodyPartPage('CONU','Nuca')" />
        <area shape="circle" coords="369,705,50" alt="Collo in generale" (click)="showBodyPartPage('COZG','Collo')" />
        <area shape="circle" coords="268,754,50" alt="Gola"  (click)="showBodyPartPage('COGO','Gola')" />
        <!--  -->
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'B' || genderAge === 'N'" class="head-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_02_testa.png" usemap="#Map-head-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-head-child">
        <area shape="circle" coords="346,240,48" alt="capelli" (click)="showBodyPartPage('TECH', 'Capelli')" />
        <area shape="circle" coords="141,356,48" alt="fronte" (click)="showBodyPartPage('TEFR','Fronte')" />
        <area shape="circle" coords="548,367,48" alt="cranio" (click)="showBodyPartPage('TECR','Cranio')" />
        <area shape="circle" coords="112,492,48" alt="occhi" (click)="showBodyPartPage('TEYE','Occhi')" />
        <area shape="circle" coords="55,570,48" alt="naso"  (click)="showBodyPartPage('TENE','Naso')" />
        <area shape="circle" coords="336,534,48" alt="orecchie"  (click)="showBodyPartPage('TEOR','Orecchie')" />
        <area shape="circle" coords="96,672,50" alt="bocca"  (click)="showBodyPartPage('TEBO','Bocca')" />
        <area shape="circle" coords="227,620,52" alt="guancia"  (click)="showBodyPartPage('TEVI','Guancia')" />
        <area shape="circle" coords="455,726,48" alt="nuca" (click)="showBodyPartPage('CONU','Nuca')" />
        <area shape="circle" coords="360,750,48" alt="collo"  (click)="showBodyPartPage('COZG','Collo')" />
        <area shape="circle" coords="269,786,48" alt="gola" (click)="showBodyPartPage('COGO','Gola')" />
        <!--  -->
        <area shape="rect" coords="20,941,111,1004" alt="indietro" (click)="showPrincipalPage()" />
    </map>
    </div>
  </div>

  <div *ngIf="viewDetail === 'triage-chaist'">
    <div *ngIf="genderAge === 'M'" class="chaist-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_04_torace.png" usemap="#Map-chaist-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map id="Map-chaist-man" name="Map-chaist-man">
        <area shape="circle" coords="230,416,50" alt="Tutto torace" (click)="showBodyPartPage('THZG','Torace')" />
        <area shape="circle" coords="163,555,50" alt="Petto" (click)="showBodyPartPage('THSE','Petto')" />
        <!--  -->
        <area shape="poly" coords="15,1009,115,1008,116,989,87,989,87,976,75,964,76,958,76,953,72,946,66,942,60,941,52,941,47,944,42,954,41,962,44,968,49,973,56,974,60,974,64,974,74,985,74,989,16,989" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'F'" class="chaist-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_03_torace.png" usemap="#Map-chaist-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-chaist-woman">
        <area shape="circle" coords="210,421,50" alt="Tutto torace" (click)="showBodyPartPage('THZG','Torace')" />
        <area shape="circle" coords="99,577,50" alt="Seno" (click)="showBodyPartPage('THSE','Seno')" />
        <!--  -->
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'B' || genderAge === 'N'" class="chaist-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_03_torace.png" usemap="#Map-chaist-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-chaist-child">
        <area shape="circle" coords="211,332,48" alt="torace" (click)="showBodyPartPage('THZG','Torace')" />
        <area shape="circle" coords="183,439,48" alt="petto"  (click)="showBodyPartPage('THSE','Petto')" />
        <!--  -->
        <area shape="rect" coords="18,941,111,1006" alt="indietro" (click)="showPrincipalPage()" />
    </map>
    </div>
  </div>

  <div *ngIf="viewDetail === 'triage-arms'">
    <div *ngIf="genderAge === 'M'" class="arms-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_06_braccia.png" usemap="#Map-arms-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map id="Map-arms-man" name="Map-arms-man">
        <area shape="circle" coords="343,324,50" alt="Spalla" (click)="showBodyPartPage('BREP','Spalla')" />
        <area shape="circle" coords="405,485,50" alt="Braccio sup." (click)="showBodyPartPage('BRHB','Braccio_sup.')" />
        <area shape="circle" coords="451,632,50" alt="Gomito" (click)="showBodyPartPage('BRCO','Gomito')" />
        <area shape="circle" coords="468,792,50" alt="Avambraccio" (click)="showBodyPartPage('BRAB','Avambraccio')" />
        <!--  -->
        <area shape="rect" coords="14,865,106,928" alt="braccio intero" (click)="showBodyPartPage('BRZG','Braccio')" />
        <area shape="poly" coords="15,1009,115,1008,116,989,87,989,87,976,75,964,76,958,76,953,72,946,66,942,60,941,52,941,47,944,42,954,41,962,44,968,49,973,56,974,60,974,64,974,74,985,74,989,16,989" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'F'" class="arms-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_05_braccia.png" usemap="#Map-arms-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-arms-woman">
        <area shape="circle" coords="366,333,50" alt="Spalla" (click)="showBodyPartPage('BREP','Spalla')" />
        <area shape="circle" coords="423,478,50" alt="Braccio sup." (click)="showBodyPartPage('BRHB','Braccio_sup.')" />
        <area shape="circle" coords="468,620,50" alt="Gomito" (click)="showBodyPartPage('BRCO','Gomito')" />
        <area shape="circle" coords="487,779,50" alt="Avambraccio" (click)="showBodyPartPage('BRAB','Avambraccio')" />
        <!--  -->
        <area shape="rect" coords="14,865,106,928" alt="braccio intero" (click)="showBodyPartPage('BRZG','Braccio')" />
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'B' || genderAge === 'N'" class="arms-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_04_braccia.png" usemap="#Map-arms-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-arms-child">
        <area shape="circle" coords="354,246,48" alt="spalla" (click)="showBodyPartPage('BREP','Spalla')" />
        <area shape="circle" coords="337,405,48" alt="braccio sup." (click)="showBodyPartPage('BRHB','Braccio_sup.')" />
        <area shape="circle" coords="311,560,48" alt="gomito" (click)="showBodyPartPage('BRCO','Gomito')" />
        <area shape="circle" coords="283,684,48" alt="avambraccio" (click)="showBodyPartPage('BRAB','Avambraccio')" />
        <!--  -->
        <area shape="rect" coords="16,866,103,925" alt="braccio" (click)="showBodyPartPage('BRZG','Braccio')" />
        <area shape="rect" coords="14,942,107,1006" alt="indietro" (click)="showPrincipalPage()" />
    </map>
    </div>
  </div>

  <div *ngIf="viewDetail === 'triage-back'">
    <div *ngIf="genderAge === 'M'" class="back-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_05_schiena.png" usemap="#Map-back-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map id="Map-back-man" name="Map-back-man">
        <area shape="circle" coords="420,253,50" alt="Schiena sup." (click)="showBodyPartPage('DOHD','Schiena_sup')" />
        <area shape="circle" coords="333,852,50" alt="Schiena inf." (click)="showBodyPartPage('DOBD','Schiena_inf')" />
        <!--  -->
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'F'" class="back-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_04_schiena.png" usemap="#Map-back-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-back-woman">
        <area shape="circle" coords="473,280,50" alt="Schiena sup." (click)="showBodyPartPage('DOHD','Schiena_sup')" />
        <area shape="circle" coords="376,908,50" alt="Schiena inf." (click)="showBodyPartPage('DOBD','Schiena_inf')" />
        <!--  -->
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'B' || genderAge === 'N'" class="back-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_05_schiena.png" usemap="#Map-back-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-back-child">
        <area shape="circle" coords="420,318,48" alt="schiena sup." (click)="showBodyPartPage('DOHD','Schiena sup.')" />
        <area shape="circle" coords="367,616,48" alt="schiena inf." (click)="showBodyPartPage('DOBD','Schiena inf.')" />
        <!--  -->
        <area shape="rect" coords="18,941,110,1006" alt="indietro" (click)="showPrincipalPage()" />
    </map>
    </div>
  </div>

  <div *ngIf="viewDetail === 'triage-stomach'">
    <div *ngIf="genderAge === 'M'" class="stomach-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_08_stomaco.png" usemap="#Map-stomach-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map id="Map-stomach-man" name="Map-stomach-man">
        <area shape="circle" coords="131,400,50" alt="Stomaco generale" (click)="showBodyPartPage('VEZG','Stomaco')" />
        <area shape="circle" coords="135,573,50" alt="Inguine" (click)="showBodyPartPage('VEAI','Inguine')" />
        <!--  -->
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'F'" class="stomach-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_07_stomaco.png" usemap="#Map-stomach-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-stomach-woman">
        <area shape="circle" coords="159,412,50" alt="Stomaco generale" (click)="showBodyPartPage('VEZG','Stomaco')" />
        <area shape="circle" coords="157,634,50" alt="Inguine" (click)="showBodyPartPage('VEAI','Inguine')" />
        <!--  -->
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'B' || genderAge === 'N'" class="stomach-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_06_stomaco.png" usemap="#Map-stomach-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-stomach-child">
        <area shape="circle" coords="200,627,48" alt="stomaco" (click)="showBodyPartPage('VEZG','Stomaco')" />
        <area shape="circle" coords="206,752,48" alt="inguine" (click)="showBodyPartPage('VEAI','Inguine')" />
        <!--  -->
        <area shape="rect" coords="18,941,111,1006" alt="indietro" (click)="showPrincipalPage()" />
    </map>
    </div>
  </div>

  <div *ngIf="viewDetail === 'triage-pelvis'">
    <div *ngIf="genderAge === 'M'" class="pelvis-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_09_bacino.png" usemap="#Map-pelvis-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map id="Map-pelvis-man" name="Map-pelvis-man">
        <area shape="circle" coords="131,572,50" alt="Inguine" (click)="showBodyPartPage('BAAI','Inguine')" />
        <area shape="circle" coords="296,570,50" alt="Fianchi" (click)="showBodyPartPage('BAHA','Fianchi')" />
        <area shape="circle" coords="130,777,50" alt="Genitali" (click)="showBodyPartPage('BAGH','Genitali')" />
        <area shape="circle" coords="470,671,50" alt="Natiche" (click)="showBodyPartPage('BAFE','Natiche')" />
        <!--  -->
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'F'" class="pelvis-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_08_bacino.png" usemap="#Map-pelvis-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-pelvis-woman">
        <area shape="circle" coords="177,633,50" alt="Inguine" (click)="showBodyPartPage('BAAI','Inguine')" />
        <area shape="circle" coords="347,632,50" alt="Fianchi"  (click)="showBodyPartPage('BAHA','Fianchi')" />
        <area shape="circle" coords="178,734,50" alt="Genitali" (click)="showBodyPartPage('BAGF','Genitali')" />
        <area shape="circle" coords="496,756,50" alt="Natiche" (click)="showBodyPartPage('BAFE','Natiche')" />
        <!--  -->
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'B' || genderAge === 'N'" class="pelvis-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_08_bacino.png" usemap="#Map-pelvis-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-pelvis-child">
        <area shape="circle" coords="217,737,48" alt="inguine" (click)="showBodyPartPage('BAAI','Inguine')" />
        <area shape="circle" coords="336,742,48" alt="fianchi" (click)="showBodyPartPage('BAHA','Fianchi')" />

        <area if.bind="!isWoman" shape="circle" coords="199,831,48" alt="genitali" (click)="showBodyPartPage('BAGH','Genitali')" />
        <area if.bind="isWoman" shape="circle" coords="199,831,48" alt="genitali" (click)="showBodyPartPage('BAGF','Genitali')" />

        <area shape="circle" coords="422,795,48" alt="natiche" (click)="showBodyPartPage('BAFE','Natiche')" />
        <!--  -->
        <area shape="rect" coords="17,941,109,1006" alt="indietro" (click)="showPrincipalPage()" />
    </map>
    </div>
  </div>

  <div *ngIf="viewDetail === 'triage-hands'">
    <div *ngIf="genderAge === 'M'" class="hands-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_07_mani.png" usemap="#Map-hands-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map id="Map-hands-man" name="Map-hands-man">
        <area shape="circle" coords="353,459,50" alt="Polso" (click)="showBodyPartPage('MAPO','Polso')" />
        <area shape="circle" coords="346,590,50" alt="Posteriore mano" (click)="showBodyPartPage('MADM','Posteriore_mano')" />
        <area shape="circle" coords="229,664,50" alt="Palmo" (click)="showBodyPartPage('MAPA','Palmo')" />
        <area shape="circle" coords="262,826,50" alt="Pollice e dita" (click)="showBodyPartPage('MADP','Pollice_e_dita')" />
        <!--  -->
        <area shape="rect" coords="19,847,104,928" alt="mani intera" (click)="showBodyPartPage('MAZG','Mano')" />
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'F'" class="hands-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_06_mani.png" usemap="#Map-hands-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-hands-woman">
        <area shape="circle" coords="355,480,50" alt="Polso" (click)="showBodyPartPage('MAPO','Polso')" />
        <area shape="circle" coords="351,608,50" alt="Posteriore mano" (click)="showBodyPartPage('MADM','Posteriore_mano')" />
        <area shape="circle" coords="250,675,50" alt="Palmo" (click)="showBodyPartPage('MAPA','Palmo')" />
        <area shape="circle" coords="284,845,50" alt="Pollice e dita" (click)="showBodyPartPage('MADP','Pollice_e_dita')" />
        <!--  -->
        <area shape="rect" coords="19,847,104,928" alt="Mano intera" (click)="showBodyPartPage('MAZG','Mano')" />
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'B' || genderAge === 'N'" class="hands-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_07_mani.png" usemap="#Map-hands-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-hands-child">
        <area shape="circle" coords="330,442,48" alt="polso" (click)="showBodyPartPage('MAPO','Polso')" />
        <area shape="circle" coords="325,570,48" alt="posteriore mano" (click)="showBodyPartPage('MADM','Posteriore_mano')" />
        <area shape="circle" coords="209,595,48" alt="palmo" (click)="showBodyPartPage('MAPA','Palmo')" />
        <area shape="circle" coords="230,827,48" alt="pollice e dita" (click)="showBodyPartPage('MADP','Pollice_e_dita')" />
        <!--  -->
        <area shape="rect" coords="21,850,99,926" alt="mano" (click)="showBodyPartPage('MAZG','Mano')" />
        <area shape="rect" coords="15,942,105,1006" alt="indietro" (click)="showPrincipalPage()" />
    </map>
    </div>
  </div>

  <div *ngIf="viewDetail === 'triage-legs'">
    <div *ngIf="genderAge === 'M'" class="legs-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_10_gambe.png" usemap="#Map-legs-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map id="Map-legs-man" name="Map-legs-man">
        <area shape="circle" coords="323,246,50" alt="Coscia" (click)="showBodyPartPage('JACU','Coscia')" />
        <area shape="circle" coords="368,433,50" alt="Post. ginocchio" (click)="showBodyPartPage('JAAG','Ginocchio_post')" />
        <area shape="circle" coords="262,433,50" alt="Ginocchio" (click)="showBodyPartPage('JAGE','Ginocchio')" />
        <area shape="circle" coords="387,601,50" alt="Polpaccio" (click)="showBodyPartPage('JAMO','Polpaccio')" />
        <area shape="circle" coords="336,762,50" alt="Tibia" (click)="showBodyPartPage('JATI','Tibia')" />
        <!--  -->
        <area shape="rect" coords="16,837,106,930" alt="gambaintera" (click)="showBodyPartPage('JAZG','Gamba')" />
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'F'" class="legs-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_09_gambe.png" usemap="#Map-legs-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-legs-woman">
        <area shape="circle" coords="359,235,50" alt="Coscia" (click)="showBodyPartPage('JACU','Coscia')" />
        <area shape="circle" coords="409,407,50" alt="Post. ginocchio" (click)="showBodyPartPage('JAAG','Ginocchio_post')" />
        <area shape="circle" coords="295,429,50" alt="Ginocchio" (click)="showBodyPartPage('JAGE','Ginocchio')" />
        <area shape="circle" coords="424,593,50" alt="Polpaccio" (click)="showBodyPartPage('JAMO','Polpaccio')" />
        <area shape="circle" coords="373,759,50" alt="Tibia" (click)="showBodyPartPage('JATI','Tibia')" />
        <!--  -->
        <area shape="rect" coords="16,837,106,930" alt="gambaintera" (click)="showBodyPartPage('JAZG','Gamba')" />
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'B' || genderAge === 'N'" class="legs-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_09_gambe.png" usemap="#Map-legs-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-legs-child">
        <area shape="circle" coords="286,285,48" alt="coscia" (click)="showBodyPartPage('JACU','Coscia')" />
        <area shape="circle" coords="327,449,48" alt="ginocchio post." (click)="showBodyPartPage('JAAG','Ginocchio_post')" />
        <area shape="circle" coords="233,467,48" alt="ginocchio" (click)="showBodyPartPage('JAGE','Ginocchio')" />
        <area shape="circle" coords="357,612,48" alt="polpaccio" (click)="showBodyPartPage('JAMO','Polpaccio')" />
        <area shape="circle" coords="324,764,48" alt="tibia" (click)="showBodyPartPage('JATI','Tibia')" />
        <!--  -->
        <area shape="rect" coords="16,839,104,926" alt="gamba" (click)="showBodyPartPage('JAZG','Gamba')" />
        <area shape="rect" coords="13,942,104,1006" alt="indietro" (click)="showPrincipalPage()" />
    </map>
    </div>
  </div>

  <div *ngIf="viewDetail === 'triage-foots'">
    <div *ngIf="genderAge === 'M'" class="foots-man">
      <div class="image-body-parts uomo-corpo">
        <img src="/public/assets/images/Uomo_11_piedi.png" usemap="#Map-foot-man" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map id="Map-foot-man" name="Map-foot-man">
        <area shape="circle" coords="413,855,50" alt="Caviglia" (click)="showBodyPartPage('PICH','Caviglia')" />
        <area shape="circle" coords="296,907,50" alt="Dorso" (click)="showBodyPartPage('PIZG','Piede')" /><!--Piede intero?-->
        <area shape="circle" coords="448,956,50" alt="Tallone" (click)="showBodyPartPage('PITA','Tallone')" />
        <area shape="circle" coords="158,975,47" alt="Dita" (click)="showBodyPartPage('PIOR','Dita')" />
        <!--  -->
        <area shape="rect" coords="19,859,101,930" alt="piedeintero" (click)="showBodyPartPage('PIZG','Piede')" />
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'F'" class="foots-woman">
      <div class="image-body-parts donna-corpo">
        <img src="/public/assets/images/Donna_10_piedi.png" usemap="#Map-foot-woman" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-foot-woman">
        <area shape="circle" coords="412,853,50" alt="Caviglia" (click)="showBodyPartPage('PICH','Caviglia')" />
        <area shape="circle" coords="301,910,50" alt="Dorso" (click)="showBodyPartPage('PIZG','Piede')" /><!--Piede intero?-->
        <area shape="circle" coords="448,959,50" alt="Tallone" (click)="showBodyPartPage('PITA','Tallone')" />
        <area shape="circle" coords="162,978,44" alt="Dita" (click)="showBodyPartPage('PIOR','Dita')" />
        <!--  -->
        <area shape="rect" coords="19,859,101,930" alt="piedeintero" (click)="showBodyPartPage('PIZG','Piede')" />
        <area shape="poly" coords="14,1009,118,1008,118,986,86,987,86,974,75,965,76,958,74,946,68,941,56,938,46,943,41,957,46,971,54,974,62,974,65,974,75,987,15,988" alt="zoom indietro" (click)="showPrincipalPage()" />
        <!--  -->
    </map>
    </div>
    <div *ngIf="genderAge === 'B' || genderAge === 'N'" class="foots-child">
      <div class="image-body-parts bimbo-corpo">
        <img src="/public/assets/images/Bimbo_10_piedi.png" usemap="#Map-foot-child" alt="" class="container-width" width="608" height="1023" (load)="onImageLoad()"/>
    </div>
    <map name="Map-foot-child">
        <area shape="circle" coords="436,844,48" alt="caviglia" (click)="showBodyPartPage('PICH','Caviglia')" />
        <area shape="circle" coords="334,917,48" alt="piede" (click)="showBodyPartPage('PIZG','Piede')" />
        <area shape="circle" coords="467,953,48" alt="tallone" (click)="showBodyPartPage('PITA','Tallone')" />
        <area shape="circle" coords="189,965,48" alt="dita" (click)="showBodyPartPage('PIOR','Dita')" />
        <!--  -->
        <area shape="rect" coords="21,864,99,926" alt="piede" (click)="showBodyPartPage('PIZG','Piede')" />
        <area shape="rect" coords="15,941,103,1005" alt="indietro" (click)="showPrincipalPage()" />
    </map>
    </div>
  </div>
</div>
